<template>
 <div>
  <Header />
  <Introduction />
  <HonorsAwards />
  <TechnicalSupport />
 </div>
</template>

<script setup>
import Header from "./header.vue"
import Introduction from "./Introduction.vue"
import HonorsAwards from "./honorsAwards.vue"
import TechnicalSupport from "./technicalSupport.vue"
</script>

<style></style>